module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-company-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "大区",
            "clearable": true
          },
          model: {
            value: (_vm.regionCode),
            callback: function($$v) {
              _vm.regionCode = $$v
            },
            expression: "regionCode"
          }
        }, _vm._l((_vm.regionCodeList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "企业名称",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.managerAdminuser
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "客户成功经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 3
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.successfulManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "经销商",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 4
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.agencyManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          attrs: {
            "default-value": _vm.deadTime,
            "type": "date",
            "placeholder": "过期截止日期",
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd"
          },
          model: {
            value: (_vm.deadTime),
            callback: function($$v) {
              _vm.deadTime = $$v
            },
            expression: "deadTime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('div', {
          staticClass: "tips"
        }, [_c('span', [_vm._v("正式客户总数量：")]), _c('span', {
          staticClass: "blueNumber"
        }, [_vm._v(_vm._s(_vm.total))]), _vm._v(" "), _c('span', [_vm._v("甲级正式客户数量：")]), _c('span', {
          staticClass: "redNumber"
        }, [_vm._v(_vm._s(_vm.levelTotal))]), _vm._v(" "), _c('span', [_vm._v("正式用户数：")]), _c('span', {
          staticClass: "purpleNumber"
        }, [_vm._v(_vm._s(_vm.tryTotal))]), _vm._v(" "), _c('span', [_vm._v("高校正式用户数：")]), _c('span', {
          staticClass: "colleges"
        }, [_vm._v(_vm._s(_vm.collegesTotal))]), _vm._v(" "), _c('span', [_vm._v("设计院正式用户数：")]), _c('span', {
          staticClass: "institute"
        }, [_vm._v(_vm._s(_vm.instituteTotal))])]), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "tooltip-effect": "dark",
            "data": _vm.proList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight - 36,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "60"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "regionCode",
            "label": "大区代号",
            "sortable": "custom",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.regionCode === '1') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华东大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '2') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华北大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '3') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("西北大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '4') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华南大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '5') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("西南大区")]) : _vm._e(), _vm._v(" "), (!scope.row.regionCode) ? _c('span', [_vm._v("-")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "企业名称",
            "sortable": "custom",
            "min-width": "260",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "grade",
            "label": "资质等级",
            "sortable": "custom",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.grade === '1') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("综合甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '2') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("公路甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '3') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("市政甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '4') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("公路市政甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '5') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("公路乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '6') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("市政乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '7') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("公路市政乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '9') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("高校")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '10') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("施工单位")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '8') ? _c('div', {
                staticClass: "other"
              }, [_vm._v("其他")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "natrue",
            "label": "企业性质",
            "sortable": "custom",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.natrue === '1' ? '央企' : scope.row.natrue === '2' ? '国企' : scope.row.natrue === '3' ? '民营上市' :
                scope.row.natrue === '4' ? '民营' : scope.row.natrue === '5' ? '高校' : '-') + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "zsuc",
            "label": "正式用户数",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "showname",
            "label": "地区",
            "sortable": "custom",
            "min-width": "180",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "公司管理员",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.managername ? scope.row.managername : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户经理",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.managerAdminuserName ? scope.row.managerAdminuserName : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户成功经理",
            "min-width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.successfulManagerName ?
                scope.row.successfulManagerName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "经销商",
            "min-width": "70",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.agencyManagerName ?
                scope.row.agencyManagerName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "正式产品总数",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "blue_num"
              }, [_vm._v(_vm._s(scope.row.ac ? scope.row.ac : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "即将过期产品数量",
            "min-width": "60",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "orange"
              }, [_vm._v(_vm._s(scope.row.dc ? scope.row.dc : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tooltip', {
                staticClass: "caozuo",
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleCom(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (_vm.id == scope.row.createUser && scope.row.delFlg !== '0') ? _c('el-tooltip', {
                staticClass: "caozuo",
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增",
            "width": "850px",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            },
            "close": _vm.closedialog
          }
        }, [(_vm.addFormVisible) ? _c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业名称",
            "prop": "name"
          }
        }, [_c('el-autocomplete', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "请输入",
            "clearable": "",
            "fetch-suggestions": _vm.querySearch,
            "trigger-on-focus": false
          },
          on: {
            "select": _vm.handleSelect
          },
          model: {
            value: (_vm.addForm.name),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "name", $$v)
            },
            expression: "addForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "地区",
            "prop": "showname"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.showname),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "showname", $$v)
            },
            expression: "addForm.showname"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户地址",
            "required": ""
          }
        }, [_c('GisCommon', {
          attrs: {
            "selected": _vm.selected,
            "address": _vm.address
          },
          on: {
            "backPram": _vm.backPram
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户经理",
            "required": ""
          }
        }, [_c('SelectCommon', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            }
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'managerAdminuser'); }
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业图标",
            "required": ""
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.imageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.imageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              return _vm.handerClose('addFormVisible', 'addForm')
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片"
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.editImageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.editImageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业名称",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editForm.name),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "name", $$v)
            },
            expression: "editForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "地区",
            "prop": "showname"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editForm.showname),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "showname", $$v)
            },
            expression: "editForm.showname"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), (_vm.orderVisible) ? _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "选择人员",
            "visible": _vm.orderVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.orderVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding-bottom": "0px",
            "border": "1px solid #dfe6ec"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs2
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "120px"
          },
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "change": _vm.changeSouch2
          },
          model: {
            value: (_vm.value2),
            callback: function($$v) {
              _vm.value2 = $$v
            },
            expression: "value2"
          }
        }, _vm._l((_vm.optionsSouch2), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disSouch),
            expression: "disSouch"
          }],
          staticStyle: {
            "width": "200px"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getUser(1)
            }
          },
          model: {
            value: (_vm.proName2),
            callback: function($$v) {
              _vm.proName2 = $$v
            },
            expression: "proName2"
          }
        }), _vm._v(" "), _c('el-select', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disinvit),
            expression: "disinvit"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs2.invitValue),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "invitValue", $$v)
            },
            expression: "souchs2.invitValue"
          }
        }, _vm._l((_vm.inviValues), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), _c('el-select', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disSofttype),
            expression: "disSofttype"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs2.softtype),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "softtype", $$v)
            },
            expression: "souchs2.softtype"
          }
        }, _vm._l((_vm.softtypes), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), _c('el-date-picker', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disTime1),
            expression: "disTime1"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "注册开始时间"
          },
          model: {
            value: (_vm.souchs2.fromtime),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "fromtime", $$v)
            },
            expression: "souchs2.fromtime"
          }
        }), _vm._v(" "), _c('el-date-picker', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disTime2),
            expression: "disTime2"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "注册结束时间"
          },
          model: {
            value: (_vm.souchs2.totime),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "totime", $$v)
            },
            expression: "souchs2.totime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.getUser(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags2), function(tag2) {
          return _c('el-tag', {
            key: tag2,
            attrs: {
              "closable": "",
              "disable-transitions": false
            },
            on: {
              "close": function($event) {
                return _vm.handleClose2(tag2)
              }
            }
          }, [_vm._v("\n          " + _vm._s(tag2) + "\n        ")])
        }), _vm._v(" "), (_vm.dynamicTags2 != '') ? _c('el-button', {
          staticClass: "button-new-tag",
          attrs: {
            "size": "small"
          },
          on: {
            "click": _vm.delTags2
          }
        }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.userLoading),
            expression: "userLoading"
          }],
          ref: "userList",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "row-key": function (row) { return row.id; },
            "data": _vm.userList,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "current-change": _vm.handleSelectionChange,
            "selection-change": _vm.handleUserSelectionChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "reserve-selection": true,
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "130"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "min-width": "100",
            "xshow-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "softtype",
            "label": "软件类型",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "企业",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "intime",
            "label": "注册时间",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "border": "1px solid #dfe6ec",
            "margin-top": "0"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": " prev, pager, next",
            "current-page": _vm.pageNumber2,
            "page-size": _vm.pageSize2,
            "total": _vm.total2
          },
          on: {
            "current-change": _vm.handleCurrentChange2
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.orderVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.orderLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.clickUserSelection.apply(null, arguments)
            }
          }
        }, [_vm._v("确定")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.adminVisible) ? _c('Admin', {
          attrs: {
            "adminVisible": _vm.adminVisible,
            "companyId": _vm.companyId,
            "UserSelection": _vm.UserSelection
          },
          on: {
            "adminVisibleClose": _vm.adminVisibleClose,
            "addAdmin": _vm.addAdmin,
            "orderUserSubmit": _vm.orderUserSubmit
          }
        }) : _vm._e()]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "update:currentPage": function($event) {
              _vm.pageNumber = $event
            },
            "update:current-page": function($event) {
              _vm.pageNumber = $event
            },
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0960915a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/account/officialCustom.vue
// module id = 1712
// module chunks = 9